import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ItemAndStatus, SelectorConfig, ItemAndStatusOptions } from './va-items-and-status';
import { CommonModule } from '@angular/common';
import { VaSearchSelectModule } from '../va-search-select/va-search-select.module';

const defaultConfig: SelectorConfig = {
  alwaysFirstValue: null,
  displayProperty: null,
  sorted: true,
  placeholderText: null,
  dropdownWidth: null,
};

@Component({
  selector: 'va-items-and-status',
  templateUrl: './va-items-and-status.component.html',
  styles: [
    `
      .item-and-status-separator {
        margin-top: 5px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, VaSearchSelectModule],
})
export class ItemsAndStatusComponent {
  @Output() selection = new EventEmitter();
  @Input() options: ItemAndStatusOptions[];
  @Input() itemConfig: SelectorConfig = defaultConfig;
  @Input() statusConfig: SelectorConfig = defaultConfig;
  @Input() editionConfig: SelectorConfig = defaultConfig;
  @Input() appliedSelection: ItemAndStatus = { item: null, status: null, edition: null };
  @Input() closeSelectOnClick = true;

  addItemListItem(item: any): void {
    this.appliedSelection = { item: item, status: null, edition: null };
    this.appliedSelection.status = this.statusMenuOptions()[0];
    this.selection.emit(this.appliedSelection);
  }

  changeItemStatus(status: any): void {
    this.appliedSelection.status = status;
    this.selection.emit(this.appliedSelection);
  }

  changeItemEdition(edition: any): void {
    this.appliedSelection.edition = edition;
    this.selection.emit(this.appliedSelection);
  }

  itemMenuOptions(): any[] {
    return this.options.map((option) => option.item) || [];
  }

  statusMenuOptions(): any[] {
    return this.options.find((option) => option.item === this.appliedSelection.item)!.statuses;
  }

  editionMenuOptions(): any[] {
    return this.options.find((option) => option.item === this.appliedSelection.item)!.editions;
  }
}
